import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects the admin-managed tracking/analytics snippet into <head> on every page (once).
export default function TrackerLoader() {
  useEffect(() => {
    let cancelled = false;
    api.get("/embeds/tracker").then((r) => {
      if (cancelled) return;
      const html = (r.data?.html || "").trim();
      if (!html || document.getElementById("__vok_tracker")) return;
      const wrap = document.createElement("div");
      wrap.innerHTML = html;
      wrap.querySelectorAll("script").forEach((old) => {
        const s = document.createElement("script");
        [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
        s.text = old.text;
        document.head.appendChild(s);
      });
      const marker = document.createElement("meta");
      marker.id = "__vok_tracker";
      document.head.appendChild(marker);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
}
